import { CloseCircleOutlined } from "@ant-design/icons";
import { Col, Empty, Image, Input, Row, Select, Spin, Switch, message } from "antd";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import React, { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { apiSaveRegistrationGeneral, apiSaveRegistrationMain } from "services/dashboardService";
import { isEmpty } from "utils/GlobalFunctions";
const RegistrationTab = (props) => {
  const { TextArea } = Input;
  const { registrationID, setRegistrationID, settingInfo, hideActionButtons } =
    props;

  // Check if this is a facility registration type
  const isFacilityType = settingInfo?.registration_info?.registration_type === 'facility';
  const userDataStore = useSelector((x) => x.userDataStore);
  const appDataStore = useSelector((x) => x.appDataStore);

  const [registrationList, setRegistrationList] = useState([
    {
      title: "",
      description: "",
      registration_fee: "",
      hours_included: "",
      addl_per_hour_fee: "",
      gl_code: "",
      gl_account_description: "",
      status: true,
      sibling_discount: true,
      sibling_discount_amount: "",
      verify_zipcode: true,
      zipcodes_allowed: "",
      zip_discount_amount: "",
      image_url: "",
      image_file: null,
      image_preview: "",
      remove_image: false,
      visible: 1
    }
  ]);
  const [errorField, setErrorField] = useState([]);
  const [isBusy, setIsBusy] = useState(false);

  useEffect(() => {
    if (settingInfo != undefined) {
      let tmpList = [...settingInfo.registration_main_list];
      if (tmpList.length > 0) {
        tmpList = tmpList.map((x) => {
          return {
            ID: x.ID,
            visible: 1,
            title: x.registration_title,
            description: x.registration_text,
            registration_fee: x.registration_fee,
            hours_included: x.hours_included || "",
            addl_per_hour_fee: x.addl_per_hour_fee || "",
            gl_code: x.GL_code || "",
            gl_account_description:
              x.GL_account_description || x.gl_account_description || "",
            status: x.open_close == 1 || x.open_close == "1" ? true : false,
            sibling_discount: x.sibling_discount == 1 ? true : false,
            sibling_discount_amount: x.sibling_discount_amount,
            verify_zipcode: x.verify_zipcode == 1 ? true : false,
            zipcodes_allowed: x.zipcodes_allowed,
            zip_discount_amount: x.zip_discount_amount,
            image_url: x.image_url || "",
            image_file: null,
            image_preview: "",
            remove_image: false,
          };
        });

        setRegistrationList(tmpList);
      }
    }
  }, [settingInfo]);
  const onAddRegItem = () => {
    let tmpList = [...registrationList];
    let oneCode = {
      title: "",
      description: "",
      registration_fee: "",
      hours_included: "",
      addl_per_hour_fee: "",
      gl_code: "",
      gl_account_description: "",
      sibling_discount: true,
      sibling_discount_amount: "",
      verify_zipcode: true,
      zipcodes_allowed: "",
      zip_discount_amount: "",
      image_url: "",
      image_file: null,
      image_preview: "",
      remove_image: false,
      visible: 1
    };
    tmpList = [...tmpList, oneCode];
    setRegistrationList(tmpList);
  };

  const toAbsoluteUrl = (url) => {
    if (!url) return "";
    if (url.startsWith("http")) return url;
    const base = process.env.REACT_APP_API?.replace("/api/", "") || "";
    const cleanPath = url.startsWith("/") ? url.slice(1) : url;
    return `${base}/${cleanPath}`;
  };

  const onDropImage = (index, e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    const file = files[0];
    const tmpList = [...registrationList];
    tmpList[index].image_file = file;
    tmpList[index].image_preview = URL.createObjectURL(file);
    tmpList[index].remove_image = false;
    setRegistrationList(tmpList);
  };

  const onRemoveImage = (index) => {
    const tmpList = [...registrationList];
    tmpList[index].image_file = null;
    tmpList[index].image_preview = "";
    tmpList[index].image_url = "";
    tmpList[index].remove_image = true;
    setRegistrationList(tmpList);
  };

  const validateFields = () => {
    let errorList = Array();
    let tmpList = [...registrationList];
    tmpList.map((x, index) => {
      errorList = isEmpty(x, "title", errorList, index);
      errorList = isEmpty(x, "description", errorList, index);
      errorList = isEmpty(x, "registration_fee", errorList, index);
      if (x.sibling_discount) {
        errorList = isEmpty(x, "sibling_discount_amount", errorList, index);
      }
      if (x.verify_zipcode) {
        errorList = isEmpty(x, "zipcodes_allowed", errorList, index);
        errorList = isEmpty(x, "zip_discount_amount", errorList, index);
      }
    });
    setErrorField([...errorList]);
    return errorList.length == 0;
  };
  const onSave = () => {
    if (!validateFields()) return;

    const formData = new FormData();
    const payloadList = registrationList.map((item, index) => {
      const imageKey = item.image_file ? `image_${index}` : "";
      if (imageKey && item.image_file) {
        formData.append(imageKey, item.image_file);
      }
      return {
        ID: item.ID,
        visible: item.visible,
        title: item.title,
        description: item.description,
        registration_fee: item.registration_fee,
        gl_code: item.gl_code,
        gl_account_description: item.gl_account_description,
        GL_account_description: item.gl_account_description,
        status: item.status,
        open_close: item.status ? 1 : 0,
        sibling_discount: item.sibling_discount,
        sibling_discount_amount: item.sibling_discount_amount,
        verify_zipcode: item.verify_zipcode,
        zipcodes_allowed: item.zipcodes_allowed,
        zip_discount_amount: item.zip_discount_amount,
        hours_included: item.hours_included || 0,
        addl_per_hour_fee: item.addl_per_hour_fee || 0,
        image_key: imageKey,
        remove_image: item.remove_image ? 1 : 0,
        image_url: item.image_url || "",
      };
    });

    formData.append("token", userDataStore.token);
    formData.append("registration_id", registrationID);
    formData.append("registration_main_list", JSON.stringify(payloadList));
    setIsBusy(true);
    apiSaveRegistrationMain(formData)
      .then((res) => {
        setIsBusy(false);
        if (
          res != undefined &&
          res.registration_main_list != undefined &&
          res.registration_id != undefined
        ) {
          setRegistrationID(res.registration_id);
          setRegistrationList([]);
          let tmpList = [...res.registration_main_list];
          tmpList = tmpList.map((x) => {
            return {
              ID: x.ID,
              visible: 1,
              title: x.registration_title,
              description: x.registration_text,
              registration_fee: x.registration_fee,
              hours_included: x.hours_included || "",
              addl_per_hour_fee: x.addl_per_hour_fee || "",
              gl_code: x.GL_code || "",
              gl_account_description:
                x.GL_account_description || x.gl_account_description || "",
              status: x.open_close == 1 || x.open_close == "1" ? true : false,
              sibling_discount: x.sibling_discount == 1 ? true : false,
              sibling_discount_amount: x.sibling_discount_amount,
              verify_zipcode: parseInt(x.verify_zipcode) == 1 ? true : false,
              zipcodes_allowed: x.zipcodes_allowed,
              zip_discount_amount: x.zip_discount_amount,
              image_url: x.image_url || "",
              image_file: null,
              image_preview: "",
              remove_image: false,
            };
          });
          setRegistrationList(tmpList);
          message.success("Registration saved successfully.");
        } else {
          message.error(res?.msg);
        }
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };
  return (
    <div>
      <Spin spinning={isBusy}>
        <Row gutter={[16, 16]} style={{ marginTop: 20 }} justify={"space-between"}>
          <Col>
            <div style={{ fontWeight: 600 }}>Registration</div>
          </Col>
          <Col>
            <CommonButton
              onClick={() => {
                onAddRegItem();
              }}
            >
              Add New Registration
            </CommonButton>
          </Col>
        </Row>
        <div>
          {registrationList.length > 0 ? (
            <div style={{ marginTop: 20 }}>
              {registrationList.map((x, index) => {
                if (x.visible == 1) {
                  return (
                    <div key={index} style={{ border: "1px solid #eee", padding: 10, marginTop: 10 }}>
                      <Row gutter={[16, 16]}>
                        <Col xs={24} sm={24}>
                          <Row style={{ paddingBottom: "5px", fontWeight: 600 }} justify={"space-between"}>
                            <Col>
                              <div>
                                Registration Title*
                              </div>
                            </Col>
                            <Col>
                              <CloseCircleOutlined
                                style={{
                                  color: "red",
                                  marginBottom: 15,
                                  cursor: "pointer",
                                  fontSize: 16,
                                }}
                                onClick={() => {
                                  let tmpList = [...registrationList];
                                  tmpList[index].visible = 0;
                                  setRegistrationList(tmpList);
                                }}
                              />
                            </Col>
                          </Row>
                          <Input
                            value={x.title}
                            className={
                              errorField !== undefined && errorField.includes(index + "title")
                                ? `common-input-error`
                                : `common-input`
                            }
                            onChange={(e) => {
                              if (errorField.includes(index + "title")) {
                                let errors = errorField.filter((y) => y != index + "title");
                                setErrorField([...errors]);
                              }
                              let tmpList = [...registrationList];
                              tmpList[index].title = e.target.value;
                              setRegistrationList(tmpList);
                            }}
                          />
                        </Col>
                      </Row>
                      <div style={{ marginTop: 10, fontWeight: 600, paddingBottom: 5 }}>
                        Registration Description*
                      </div>
                      <div>
                        <TextArea
                          rows={6}
                          value={x.description}
                          className={
                            errorField !== undefined && errorField.includes(index + "description")
                              ? `common-input-error`
                              : `common-input`
                          }
                          onChange={(e) => {
                            if (errorField.includes(index + "description")) {
                              let errors = errorField.filter((y) => y != index + "description");
                              setErrorField([...errors]);
                            }
                            let tmpList = [...registrationList];
                            tmpList[index].description = e.target.value;
                            setRegistrationList(tmpList);
                          }}
                        />
                      </div>
                      <Row align={"middle"} gutter={16} style={{ marginTop: 12 }}>
                        <Col>
                          <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                            Registration Image
                          </div>
                        </Col>
                        <Col>
                          <div className="logo_uploader">
                            <label htmlFor={`reg_image_uploader_${index}`}>
                              <input
                                type="file"
                                id={`reg_image_uploader_${index}`}
                                name={`reg_image_uploader_${index}`}
                                style={{ display: "none" }}
                                accept="image/x-png, image/jpeg, image/jpg"
                                onChange={(e) => onDropImage(index, e)}
                              />
                              <span className="custom-button common-button">
                                Browse
                              </span>
                            </label>
                          </div>
                        </Col>
                        {(x.image_preview || x.image_url) && (
                          <Col>
                            <CloseCircleOutlined
                              style={{
                                color: "red",
                                marginBottom: 15,
                                cursor: "pointer",
                                fontSize: 16,
                              }}
                              onClick={() => onRemoveImage(index)}
                            />
                          </Col>
                        )}
                      </Row>
                      {(x.image_preview || x.image_url) && (
                        <div style={{ marginTop: 10 }}>
                          <Image
                            width={120}
                            height={90}
                            src={x.image_preview || toAbsoluteUrl(x.image_url)}
                            style={{ objectFit: "cover", borderRadius: 6 }}
                            preview={false}
                          />
                        </div>
                      )}
                      <Row gutter={16} justify={"space-between"} style={{ marginTop: 10 }}>
                        <Col>
                          <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                            Registration Fee
                          </div>
                          <Input
                            value={x.registration_fee}
                            type={"number"}
                            prefix="$"
                            suffix="USD"
                            className={
                              errorField !== undefined &&
                                errorField.includes(index + "registration_fee")
                                ? `common-input-error`
                                : `common-input`
                            }
                            onChange={(e) => {
                              if (errorField.includes(index + "registration_fee")) {
                                let errors = errorField.filter(
                                  (y) => y != index + "registration_fee"
                                );
                                setErrorField([...errors]);
                              }
                              let tmpList = [...registrationList];
                              tmpList[index].registration_fee = e.target.value;
                              setRegistrationList(tmpList);
                            }}
                          />
                        </Col>
                        {isFacilityType && (
                          <>
                            <Col>
                              <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                                Hours Included
                              </div>
                              <Input
                                value={x.hours_included}
                                type={"number"}
                                min={0}
                                placeholder="0"
                                className={`common-input`}
                                onChange={(e) => {
                                  let tmpList = [...registrationList];
                                  tmpList[index].hours_included = e.target.value;
                                  setRegistrationList(tmpList);
                                }}
                              />
                            </Col>
                            <Col>
                              <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                                Addl p/Hour Fee
                              </div>
                              <Input
                                value={x.addl_per_hour_fee}
                                type={"number"}
                                prefix="$"
                                suffix="USD"
                                min={0}
                                placeholder="0.00"
                                className={`common-input`}
                                onChange={(e) => {
                                  let tmpList = [...registrationList];
                                  tmpList[index].addl_per_hour_fee = e.target.value;
                                  setRegistrationList(tmpList);
                                }}
                              />
                            </Col>
                          </>
                        )}
                        <Col>
                          <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                            GL Code
                          </div>
                          <Input
                            value={x.gl_code}
                            className={`common-input`}
                            onChange={(e) => {
                              let tmpList = [...registrationList];
                              tmpList[index].gl_code = e.target.value;
                              setRegistrationList(tmpList);
                            }}
                          />
                        </Col>
                        <Col>
                          <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                            GL Description
                          </div>
                          <Input
                            value={x.gl_account_description}
                            className={`common-input`}
                            onChange={(e) => {
                              let tmpList = [...registrationList];
                              tmpList[index].gl_account_description = e.target.value;
                              setRegistrationList(tmpList);
                            }}
                          />
                        </Col>
                        <Col>
                          <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                            Status
                          </div>
                          <Switch
                            checkedChildren="Open"
                            unCheckedChildren="Close"
                            checked={x.status}
                            style={{ marginBottom: 10 }}
                            onChange={(e) => {
                              let tmpList = [...registrationList];
                              tmpList[index].status = e;
                              setRegistrationList(tmpList);
                            }}
                          />
                        </Col>
                        <Col>
                          <Row gutter={[32, 16]}>
                            <Col>
                              <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                                Sibling Discount
                              </div>
                              <Switch
                                checkedChildren="Yes"
                                unCheckedChildren="No"
                                checked={x.sibling_discount}
                                style={{ marginBottom: 10 }}
                                onChange={(e) => {
                                  let tmpList = [...registrationList];
                                  tmpList[index].sibling_discount = e;
                                  setRegistrationList(tmpList);
                                }}
                              />
                            </Col>
                            <Col>
                              <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                                Sibling Discount Amount
                              </div>
                              <Input
                                value={x.sibling_discount_amount}
                                type={"number"}
                                prefix="$"
                                suffix="USD"
                                className={
                                  errorField !== undefined &&
                                    errorField.includes(index + "sibling_discount_amount")
                                    ? `common-input-error`
                                    : `common-input`
                                }
                                onChange={(e) => {
                                  if (errorField.includes(index + "sibling_discount_amount")) {
                                    let errors = errorField.filter(
                                      (y) => y != index + "sibling_discount_amount"
                                    );
                                    setErrorField([...errors]);
                                  }
                                  let tmpList = [...registrationList];
                                  tmpList[index].sibling_discount_amount = e.target.value;
                                  setRegistrationList(tmpList);
                                }}
                              />
                            </Col>
                          </Row>
                          <Row gutter={[32, 16]} style={{ marginTop: 10 }}>
                            <Col>
                              <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                                Verify Zip Code
                              </div>
                              <Switch
                                checkedChildren="Yes"
                                unCheckedChildren="No"
                                checked={x.verify_zipcode}
                                style={{ marginBottom: 10 }}
                                onChange={(e) => {
                                  let tmpList = [...registrationList];
                                  tmpList[index].verify_zipcode = e;
                                  setRegistrationList(tmpList);
                                }}
                              />
                            </Col>
                            <Col>
                              <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                                Zip Codes Allowed (seperate with a comma)
                              </div>
                              <Input
                                value={x.zipcodes_allowed}
                                className={
                                  errorField !== undefined &&
                                    errorField.includes(index + "zipcodes_allowed")
                                    ? `common-input-error`
                                    : `common-input`
                                }
                                onChange={(e) => {
                                  if (errorField.includes(index + "zipcodes_allowed")) {
                                    let errors = errorField.filter(
                                      (y) => y != index + "zipcodes_allowed"
                                    );
                                    setErrorField([...errors]);
                                  }
                                  let tmpList = [...registrationList];
                                  tmpList[index].zipcodes_allowed = e.target.value;
                                  setRegistrationList(tmpList);
                                }}
                              />
                            </Col>
                            <Col>
                              <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                                Zip Discount Amount
                              </div>
                              <Input
                                value={x.zip_discount_amount}
                                type={"number"}
                                prefix="$"
                                suffix="USD"
                                className={
                                  errorField !== undefined &&
                                    errorField.includes(index + "zip_discount_amount")
                                    ? `common-input-error`
                                    : `common-input`
                                }
                                onChange={(e) => {
                                  if (errorField.includes(index + "zip_discount_amount")) {
                                    let errors = errorField.filter(
                                      (y) => y != index + "zip_discount_amount"
                                    );
                                    setErrorField([...errors]);
                                  }
                                  let tmpList = [...registrationList];
                                  tmpList[index].zip_discount_amount = e.target.value;
                                  setRegistrationList(tmpList);
                                }}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  );
                }
              })}
            </div>
          ) : (
            <></>
          )}
        </div>
        {!hideActionButtons && (
          <div style={{ marginTop: 60, textAlign: "center" }}>
            <CommonButton
              style={{ padding: "12px 45px" }}
              onClick={() => {
                onSave();
              }}
            >
              Save
            </CommonButton>
          </div>
        )}
      </Spin>
    </div>
  );
};
export default RegistrationTab;
